$(document).ready(function(){
    $('#schedule_btn,#register_login_btn').click(function(){
        $('#sign_up').removeClass('d-none');
        $('#log_in').addClass('d-none');
        $('#schedule_btn').addClass('d-none');
        $('#how_to_section').addClass('d-none');
        $('#how_to_btn').removeClass('d-none');
    });
    $('#how_to_btn').click(function(){
        $('#how_to_section').removeClass('d-none');
        $('#log_in').addClass('d-none');
        $('#how_to_btn').addClass('d-none');
        $('#sign_up').addClass('d-none');
        $('#schedule_btn').removeClass('d-none');
    });
    $('#login_btn').click(function(){
        $('#log_in').removeClass('d-none');
        $('#sign_up').addClass('d-none');
        $('#schedule_btn').addClass('d-none');
        $('#how_to_section').addClass('d-none');
        $('#how_to_btn').removeClass('d-none');
    });
    var mobile = document.querySelector("#mobile_input");
    if(mobile !== null){
        mobile_input = window.intlTelInput(mobile,{
            utilsScript: '/intl-tel-input-16.0.0/build/js/utils.js',
            separateDialCode: true
        });
    }
    var timez = jstz.determine().name();
    if(timez == 'America/Indianapolis'){
        timez = 'America/Indiana/Indianapolis';
    }
    $('#tz_print').html(timez);
    var select = $('#timezone_select option:contains("' + timez + '")').attr('selected',true);
    $('#timezone_pick').timezonePicker({
        defaultValue: { value: timez, attribute: "timezone" },
        quickLink: [{
                "PST": "America/Los_Angeles",
                "MST": "America/Denver",
                "CST": "America/Chicago",
                "EST": "America/New_York",
            }]
    });
    $('#toggle_timezone').on('click',function(){
        $('#timezone_pick').toggleClass('hide');
        if($('#timezone_pick').hasClass('hide')){
            $('#toggle_timezone').html('Change My Time Zone');
        }else{
            $('#toggle_timezone').html('Close Time Zone Picker');
        }
    });
    $('#timezone_pick').on("map:value:changed", function(){
        $('#tz_print').html($(this).data('timezonePicker').getValue()[0].timezone);
    });
    $('#schedule_form').submit(function(e) {
        e.preventDefault();
        var customized = $('input[name=custom_registration]').val();
        var front_pass = fullValidate(customized);
        if(!front_pass){
            $('#register_message').css('visibility','visible');
            $('#register_message').text('You missed a required field.');
            $("html, body").animate({ scrollTop: 275 }, "slow");
            return false;
        }
        var data = $('#schedule_form').serializeArray();
        let mobile_data = data.find(element => element['name'] == 'mobile_number');
        mobile_data["value"] = mobile_input.getNumber();
        data.push({'name':'timezone','value':$(".country-lov").val()});
        ajaxCall('register',data);
    });

    $('#login_form').submit(function(e){
        e.preventDefault();
        var front_pass = loginValidate();
        if(!front_pass){
            return false;
        }
        var data = $('#login_form').serializeArray();
        ajaxCall('register-login',data);
    });

    $('#validation_form').submit(function(e){
        e.preventDefault();
        var front_pass = AccessValidate();
        if(!front_pass){
            return false;
        }
        var data = $('#validation_form').serializeArray();
        ajaxCall('validation-check',data);
    });

    $('[name="first_name"], [name="last_name"], [name="login_password"], [name="job_title"], [name="passcode"]').on('keyup',function(e){
        validateItem($(e.target).attr('name'),'');
    });

    $('[name="profession_id"], [name="specialty_id"]').on('change',function(e){
        validateItem($(e.target).attr('name'),0);
    });

    $('[name="email"], [name="email_confirmation"]').on('keyup',function(e){
        validateEmail();
    });

    $('[name="password"], [name="password_confirmation"]').on('keyup',function(e){
        validatePassword();
    });

    $('[name="mobile_number"]').on('keyup',function(e){
        validateMobile();
    });

    function ajaxCall(url,data){
        $('.submit-btn').attr('disabled','disabled');
        $('.submit-btn-txt').addClass('d-none');
        $('.loading-btn-txt').removeClass('d-none');
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('[name="csrf-token"]').val()
            }
        });
        $.ajax({
            type: 'POST',
            url: '/api/' + url,
            data: data,
            cache: false,
            success: function(response){
                $('.submit-btn').attr('disabled',false);
                $('.submit-btn-txt').removeClass('d-none');
                $('.loading-btn-txt').addClass('d-none');
                if(response == 'passed') {
                    // Only used for Partner email validation (PartnerEmailController::validation)
                    $('#validation_passed').removeClass('d-none');
                    $('#schedule_form').removeClass('d-none');
                    $('#validation_start').addClass('d-none');
                } else if (response == 'failed') {
                    $('.validation_failed').removeClass('d-none');
                } else {
                    window.location.href = response.redirect;
                }
            },
            failed: function(error){
                console.log(error);
                $('.submit-btn').attr('disabled',false);
                $('.submit-btn-txt').removeClass('d-none');
                $('.loading-btn-txt').addClass('d-none');
                $('#' + url + '_message').html(error.responseJSON.message).css('visibility','visible');
                $([document.documentElement, document.body]).animate({
                    scrollTop: $('#' + url + '_message').offset().top
                }, 2000);
            },
            error: function(error){
                console.log(error);
                if(typeof(error.responseJSON.message) == 'object'){
                    $.each(error.responseJSON.message,function(i,val){
                        $('#' + i + '_err').html(val).css('visibility','visible');
                    });
                    $('#' + url + '_message').html('There was an error processing your request. Please contact support@sp-ed.com for assistance.').css('visibility','visible');
                }else{
                    $('#' + url + '_message').html(error.responseJSON.message).css('visibility','visible');
                }
                $('.submit-btn').attr('disabled',false);
                $('.submit-btn-txt').removeClass('d-none');
                $('.loading-btn-txt').addClass('d-none');
                $([document.documentElement, document.body]).animate({
                    scrollTop: $('#' + url + '_message').offset().top
                }, 2000);
            }
        });
    }

    function fullValidate(customized){
        var front_pass = true;

        if (!customized) {
            $.each({'first_name': '','last_name': '','job_title': '','profession_id': null,'specialty_id': null},function(item,key){
                if(!validateItem(item,key)){
                    front_pass = false;
                }
            });
        } else {
            $('#schedule_form').find('input,textarea,select').each(function(){
                if ($(this).prop('required')) {
                    if(!validateItem($(this).attr('name'),'')){
                        front_pass = false;
                    }
                }
            });

            $.each({'first_name': '','last_name': ''},function(item,key){
                if(!validateItem(item,key)){
                    front_pass = false;
                }
            });
        }
        if(!validateEmail()){
            front_pass = false;
        }
        if(!validatePassword()){
            front_pass = false;
        }
        if($('[name="enable_sms"]').is(':checked') || mobile_input.getNumber() !== ''){
            if(!validateMobile()){
                front_pass = false;
            }
        }
        if(!validateTimeZone()){
            front_pass = false;
        }
        if($('[name="passcode"]').length){
            if(!validateItem('passcode','')){
                front_pass = false;
            }
        }
        return front_pass;
    }

    function loginValidate(){
        var front_pass = true;
        $.each({'login_email':'','login_password':''},function(item,key){
            if(!validateItem(item,key)){
                front_pass = false;
            }
        });
        return front_pass;
    }

    function AccessValidate(){
        var front_pass = true;
        $.each({'email_validation':''},function(item,key){
            if(!validateItem(item,key)){
                front_pass = false;
            }
        });
        return front_pass;
    }

    function validateItem(key,validation){
        var front_pass = true;
        if($('[name="' + key + '"]').val() == validation || $('[name="' + key + '"]').val() == null){
            front_pass = false;
            $('#' + key + '_err').html(key.charAt(0).toUpperCase() + key.slice(1).replace('_',' ').replace(' id','') + ' is required.').css('visibility','visible');
            $('[name="' + key + '"]').css('border-bottom','2px solid #910a00');
            if(key == 'profession_id' || key == 'specialty_id'){
                $('[name="' + key + '"]').css('font-style','italic').css('color','#acacac');
            }
        }else{
            $('#' + key + '_err').html('&nbsp;').css('visibility','hidden');
            $('[name="' + key + '"]').css('border-bottom','');
            $('[name="' + key + '"]').css('font-style','normal').css('color','#787878');
        }
        return front_pass;
    }

    function validateEmail(){
        var front_pass = true;
        if($('[name="email"]').val() == ''){
            front_pass = false;
            $('#email_err').html('Email field is required.').css('visibility','visible');
            $('[name="email"]').css('border-bottom','2px solid #910a00');
            $('[name="email_confirmation"]').css('border-bottom','2px solid #910a00');
        }else if($('[name="email"]').val() !== $('[name="email_confirmation"]').val()){
            front_pass = false;
            $('#email_err').html('Email confirmation does not match.').css('visibility','visible');
            $('[name="email"]').css('border-bottom','2px solid #910a00');
            $('[name="email_confirmation"]').css('border-bottom','2px solid #910a00');
        }else{
            $('#email_err').html('&nbsp;').css('visibility','hidden');
            $('[name="email"]').css('border-bottom','');
            $('[name="email_confirmation"]').css('border-bottom','');
        }
        return front_pass;
    }

    function validatePassword(){
        var front_pass = true;
        if($('[name="password"]').val() == ''){
            front_pass = false;
            $('#password_err').html('Password is required.').css('visibility','visible');
            $('[name="password"]').css('border-bottom','2px solid #910a00');
            $('[name="password_confirmation"]').css('border-bottom','2px solid #910a00');
        }else if($('[name="password"]').val().length < 8){
            front_pass = false;
            $('#password_err').html('Password must be at least 8 characters.').css('visibility','visible');
            $('[name="password"]').css('border-bottom','2px solid #910a00');
            $('[name="password_confirmation"]').css('border-bottom','2px solid #910a00');
        }else if($('[name="password"]').val() !== $('[name="password_confirmation"]').val()){
            front_pass = false;
            $('#password_err').html('Password confirmation does not match.').css('visibility','visible');
            $('[name="password"]').css('border-bottom','2px solid #910a00');
            $('[name="password_confirmation"]').css('border-bottom','2px solid #910a00');
        }else{
            $('#password_err').html('&nbsp;').css('visibility','hidden');
            $('[name="password"]').css('border-bottom','');
            $('[name="password_confirmation"]').css('border-bottom','');
        }
        return front_pass;
    }

    function validateMobile(){
        var front_pass = true;
        if(!mobile_input.isValidNumber()){
            front_pass = false;
            var phone_errs = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
            var ph_err_num = mobile_input.getValidationError();
            var msg = "You must enter a valid phone number. " + phone_errs[ph_err_num] + '.';
            $('#mobile_number_err').html(msg).css('visibility','visible');
        }else{
            $('#mobile_number_err').html('&nbsp;').css('visibility','hidden');
        }
        return front_pass;
    }

    function validateTimeZone(){
        var front_pass = true;
        if($('.country-lov').val() == ''){
            front_pass = false;
            $('#timezone_err').html('Please provide a valid time zone.').css('visibility','visible');
        }else{
            $('#timezone_err').html('&nbsp;').css('visibility','hidden');
        }
        return front_pass;
    }
});
